var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.233 18.1702V28.3753C24.2316 29.1112 23.9387 29.8166 23.4183 30.3369C22.898 30.8573 22.1926 31.1502 21.4567 31.1515H3.88631C3.52708 31.1522 3.17123 31.082 2.83922 30.9449C2.5072 30.8077 2.20553 30.6064 1.95152 30.3524C1.69751 30.0984 1.49619 29.7967 1.35904 29.4647C1.22189 29.1327 1.15165 28.7768 1.15235 28.4176V3.88552C1.15165 3.52629 1.22189 3.17044 1.35904 2.83842C1.49619 2.50641 1.69751 2.20474 1.95152 1.95073C2.20553 1.69671 2.5072 1.49539 2.83922 1.35824C3.17123 1.22109 3.52708 1.15086 3.88631 1.15156H21.4567C22.1926 1.15295 22.898 1.44585 23.4183 1.96619C23.9387 2.48653 24.2316 3.19191 24.233 3.92778V12.6786",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4051 7.96008H5.97266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4051 13.4281H5.97266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6863 18.8961H5.97266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90561 24.4915H6.01562",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7656 25.0091C16.349 25.0672 17.6527 24.6449 18.5236 23.774L30.6946 11.6031C31.0429 11.26 30.7579 10.4102 30.0612 9.71353C29.3645 9.01683 28.5149 8.73185 28.1665 9.0802L16.0271 21.246C15.5698 21.7521 15.2236 22.3485 15.0108 22.9966C14.7981 23.6448 14.7236 24.3304 14.792 25.0091H14.7656Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.58643ffc8dcadf3b4c321d4db2f99907.svg";
export { ForwardRef as ReactComponent };